module.exports = __webpack_public_path__ + "img/cambria.42a78eb8.png";